import { GraphDataQualityWarning } from '../../../data-catalog-shared';

export const emptyWarnings: ReadonlyArray<GraphDataQualityWarning> = [];

export function filterOutWarningsFromAnchorUntilCycleIsFixed(nodeId: string, upstream?: ReadonlyArray<GraphDataQualityWarning>): ReadonlyArray<GraphDataQualityWarning> {
  if (!upstream) {
    return emptyWarnings;
  }

  return upstream?.filter(w => w.asset?.id !== nodeId);
}
